import * as type from './type';

export const getCharacterFavorite = (params) => {
  return {
    type: type.GET_CHARACTER_FAVORITE,
    params,
  };
};

export const getCharacterFavoriteSuccess = (payload) => {
  return {
    type: type.GET_CHARACTER_FAVORITE_SUCCESS,
    payload,
  };
};


export const getCharacterRequest = (params) => {
  // console.log(params, 'getCharacterRequest');
  return {
    type: type.GET_CHARACTER_REQUEST,
    params,
  };
};

export const getCharacterSuccess = (payload) => {
  // console.log(payload, 'payloadpayload');
  return {
    type: type.GET_CHARACTER_SUCCESS,
    payload,
  };
};

export const getCharacterDetailRequest = (params) => {
  return {
    type: type.GET_CHARACTER_DETAIL_REQUEST,
    params,
  };
};

export const getCharacterDetailSuccess = (payload) => {
  // console.log(payload, 'payloadpayload');
  return {
    type: type.GET_CHARACTER_DETAIL_SUCCESS,
    payload,
  };
};

export const resetCharacters = (payload) => {
  return {
    type: type.RESET_CHARACTER,
    payload,
  };
};
